module.exports = __webpack_public_path__ + "img/ylkt4.97f659a3.jpg";